import styled from 'styled-components';

export default styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  z-index: 10;
  background: white;
  
  box-shadow: 0 10px 18px -2px rgba(0,0,0,0.75);
`;
